<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <!-- <div class="modal_close_btn">
          <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
        </div> -->
        <!-- Modal content-->
        <div mat-dialog-content> 
          <!-- Modal-Body -->
          <div class="modal-body br-8">
            <div class="modal_close_btn">
              <span (click)="dialogClose('no')" class="modal-close"><i class="material-icons">close</i></span>
            </div>
            <div class="profile_complition_details">
           <!--   <div class="status_img">
                <img src="../../../../../assets/images/profile_complition.jpg" alt="">
              </div>-->
              <div class="status_content">
                 <div class="icon-container">
                     <svg width="100%" height="100%" class="alert-icon"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
 </svg></div>
            
                         <p style="padding-left: 0; padding-right: 0;">{{data.message}}</p>

                <div fxLayout="column" fxLayoutAlign="center center" style="flex-direction: column; box-sizing: border-box; display: flex; place-content: center; align-items: center;">
                  <!-- <button class="btn btn-sm global-btn" (click)="dialogClose()" mat-button [routerLink]="['/sign-up',data?.present_subscription_id,data?.id]">Continue</button> -->
                  <!-- <button class="btn btn-sm global-btn" (click)="dialogClose()" mat-button [routerLink]="['/sign-up',data?.present_subscription_id,data?.id]">Continue</button> -->
               <!--  <button class="btn btn-sm global-btn" (click)="onContinue()" mat-button>Continue</button> --> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




